export const GET_STATISTIC = `
query($type: String, $range: String, $code: String) {
  statistic(type: $type, range: $range, code: $code) {
    label
    value
  }
}`;

export const GET_SPECIFIC_STATISTIC = `
query($type: String, $range: String, $code: String) {
  specificStatistic(type: $type, range: $range, code: $code) {
    label
    value
  }
}`;

export const EXAM_RECORDS = `
query($page: Int, $size: Int, $code: String) {
  examRecords(page: $page, size: $size, code: $code) {
    total
    list {
      id
      coursesName
      testType
      type
      unitName
      testTime
      timeConsuming
      score
      isPass
      afterExamId
      trophyId
    }
  }
}
`;

export const RANK_LIST = `
query($type: String, $range: String) {
  rankingList(type: $type, range: $range) {
    rank
    account {
      account
      name
      title
    }
    value
  }
}
`;

export const EXAM_TYPES = `
query($type: String) {
  examTypes(type: $type) {
    id
    name
  }
}
`;

export const COURSE_REPOER_LABEL_LIST = `
query {
  CourseReportLabelList {
    label
    value
    status
    subset {
      label
      value
      status
    }
  }
}
`;
